export const useSafeRedirect = () => {
  const { allowedRedirects = [] } = useAppConfig().components.form.signIn

  const isSafe = (url: string | undefined): url is string => {
    if (!url) return false
    if (url.startsWith('/')) return true // this is internal path, safe to redirect to

    try {
      const { hostname, protocol } = new URL(url)
      if (protocol !== 'https:') return false
      return allowedRedirects.some((allowed) => {
        try {
          return new URL(allowed).hostname === hostname
        }
        catch {
          return false
        }
      })
    }
    catch {
      return false
    }
  }

  const redirect = (url: string | undefined) => {
    if (!isSafe(url)) return
    navigateTo(url, { external: !url.startsWith('/') })
  }

  return { isSafe, redirect }
}
